import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

const AboutCompound = ({
  name,
  description
}: {
  name: string;
  description: string;
}) => {
  const { t } = useTranslation('entity');

  return (
    <Container>
      <h3 className="headline">
        {t('about')} {name}
      </h3>

      <div
        className="description"
        dangerouslySetInnerHTML={{
          __html: description
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  .description {
    font-family: materialRegular;

    div:first-child {
      padding: 8px;
    }

    p,
    strong,
    span,
    li,
    div {
      color: ${props => props.theme.light.colors.black} !important;
    }
    p {
      margin-bottom: 4px;
    }

    ul {
      li {
        list-style: disc;
        list-style-position: inside;
      }
    }

    ol {
      li {
        list-style-position: inside;
        position: relative;

        span {
          position: absolute;
          inset-inline-start: 25px;
        }
      }
    }

    strong {
      font-size: ${props => props.theme.font.sizes.l};
      font-family: materialBold;
    }
  }
`;

export default AboutCompound;
